import { getConferenceName } from '../../../../react/features/base/conference/functions';
import { getUserJidFirstPart } from '../../../functions.any';
import { KINESIS_MESSAGES, SEND_EVENTS_INTERVAL } from './constants';
import { buildEventDataByFilter, getWildixPlatform, isKinesisLogsEnabled, normalizePbxHost } from './functions';
let events = [];
let sendEventsTimer = null;
let sendImmediately = false;
export function setSendImmediately(value) {
    sendImmediately = value;
}
export function sendToFirehose(data) {
    return (dispatch) => {
        // TODO: change on mobile version
        if (typeof APP !== 'undefined') {
            APP.WildixAPI.AwsApi.sendToFirehose(data);
        }
    };
}
export function sendKinesisEvent(eventData) {
    return (dispatch, getState) => {
        if (!isKinesisLogsEnabled(getState())) {
            return;
        }
        try {
            const state = getState();
            const { roomToken, pbxUser, pbxSerial, pbxHost, pbxExtension } = state['features/base/config'];
            const { displayName, email } = state['features/base/settings'];
            const subject = getConferenceName(state);
            const { conference } = state['features/base/conference'];
            const expandedEvent = {
                ...eventData,
                conferenceId: roomToken,
                conferenceTitle: subject,
                displayName,
                userId: getUserJidFirstPart(conference),
                userResource: conference?.myUserId() || '',
                platform: getWildixPlatform(getState),
                timestamp: Date.now()
            };
            if (email) {
                expandedEvent.email = email;
            }
            if (!pbxUser && !pbxSerial) {
                expandedEvent.userType = 'external';
            }
            else {
                expandedEvent.userType = 'internal';
                expandedEvent.pbxSerial = pbxSerial;
                expandedEvent.pbxHost = normalizePbxHost(pbxHost, pbxUser, expandedEvent.userId);
                expandedEvent.pbxExtension = pbxExtension;
            }
            events.push(expandedEvent);
            if (sendImmediately) {
                sendImmediately = false;
                dispatch(sendArrayEvents());
            }
            else if (!sendEventsTimer) {
                sendEventsTimer = setTimeout(() => dispatch(sendArrayEvents()), SEND_EVENTS_INTERVAL);
            }
        }
        catch (error) {
            console.error('[WILDIX kinesis] Error sending event:', error);
        }
    };
}
export function sendArrayEvents() {
    return (dispatch) => {
        if (events.length === 0) {
            return;
        }
        dispatch(sendToFirehose(events));
        events = [];
        sendEventsTimer = null;
    };
}
export function sendEventByFilter(event) {
    return (dispatch, getState) => {
        const store = { dispatch,
            getState };
        const data = buildEventDataByFilter(event, store);
        if (data) {
            dispatch(sendKinesisEvent(data));
        }
    };
}
export function sendConferenceJoinedEvent() {
    return (dispatch) => {
        dispatch(sendKinesisEvent({
            message: KINESIS_MESSAGES.conferenceJoined
        }));
    };
}
export function sendConferenceDisposeEvent() {
    return (dispatch) => {
        setSendImmediately(true);
        dispatch(sendKinesisEvent({
            message: KINESIS_MESSAGES.conferenceDispose
        }));
    };
}
export function sendSharedVideoEvent(videoState) {
    return (dispatch) => {
        dispatch(sendKinesisEvent({
            message: `shared video ${videoState}`
        }));
    };
}
